module.exports = __webpack_public_path__ + "static/img/icon3.6733e74f.png";